import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { parseMemorySplat } from "@/lib/memory-browse";
import { isReservedOwnerSegment } from "@/lib/reserved";
import { entitySplatFromPathname } from "@/lib/resolve-entity-path";
import {
	decodeEntityTypeParam,
	reencodeLiteralEntityTypePath,
} from "@/lib/url";

/**
 * Legacy path form: `/memory/<type>` is the type page `/{owner}/<type>`, and
 * `/memory/<type>/<slug>[/…]` the record page `/{owner}/<type>/<slug>[/…]`
 * (the record catch-all re-encodes `$`-types itself).
 */
export const Route = createFileRoute("/$owner/memory/$")({
	beforeLoad: ({ params, location }) => {
		const splat = parseMemorySplat(
			entitySplatFromPathname(location.pathname, 1),
		);
		if (!splat.typeSegment) {
			throw redirect({
				to: "/$owner/data",
				params: { owner: params.owner },
				search: {},
				replace: true,
			});
		}
		if (isReservedOwnerSegment(splat.typeSegment)) {
			throw notFound();
		}
		if (splat.isEntityDetail) {
			throw redirect({
				to: reencodeLiteralEntityTypePath(
					`/${params.owner}/${splat.path}`,
				) as "/",
				search: {},
				replace: true,
			});
		}
		throw redirect({
			to: "/$owner/$entityType",
			params: {
				owner: params.owner,
				entityType: decodeEntityTypeParam(splat.typeSegment),
			},
			search: { create: undefined },
			replace: true,
		});
	},
	component: () => null,
});
